export default __webpack_public_path__ + "static/media/pantry1-afterA-2048w.d7d79ea7.webp";